export const eventApi = {
  BOOK_SINGLE_EVENT_FOR_B2B: `/api/fair/event/join/b2b`,
  BOOK_SINGLE_EVENT_FOR_VISITOR: `/api/fair/event/join/visitor`,
  GET_SINGLE_EVENT_BY_EVENT_ID: (eventId: number) =>
    `/api/fair/event/${eventId}`,
  GET_ALL_EVENT_LIST: `/api/fair/event`,
};
